/** 結果画面から検討を始めるボタン。 終局した盤をサーバに上げて検討を作る。 */
import { useState } from 'react';
import { navigate } from '../lib/navigate';
import type { Snapshot } from '../lib/match-snapshot';
import { createStudy } from '../state/study';

interface Props {
  snapshot: Snapshot | null;
  title: string;
  players: string[];
  outcome: string | null;
  /** 開いた人の席。 観戦者は null。 */
  seat: string | null;
}

export function StudyButton({ snapshot, title, players, outcome, seat }: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!snapshot?.boards?.length) return null;
  const start = async () => {
    setBusy(true);
    setError(null);
    try {
      const id = await createStudy({
        title,
        players,
        outcome,
        creator_seat: seat,
        host_seat: snapshot.host_seat ?? null,
        boards: snapshot.boards.map((b) => ({
          board: b.board,
          game_id: b.game_id,
          result: b.result,
          final_state: b.state,
          first_seat: b.first_seat ?? null,
          moves: b.history.map((h) => h.mv),
        })),
      });
      navigate(`/study/${id}/${snapshot.boards[0].board}`);
    } catch (e) {
      setError(e instanceof Error ? e.message : '検討を作れませんでした');
      setBusy(false);
    }
  };
  return (
    <>
      <button className="btn-secondary" onClick={() => void start()} disabled={busy} data-testid="start-study">
        {busy ? '準備中…' : '検討する'}
      </button>
      {error && <p className="error">{error}</p>}
    </>
  );
}
